import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'smarthome',
    component: Children,

    children: [
      {
        path: '',
        name: 'smarthome',
        component: () => import('../pages/SmartHomePage.vue')
      }
    ]
  }
];

export default routes;
